module.exports = __webpack_public_path__ + "static/media/4.03f4d664.JPG";